import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingDispatchDetailView from 'src/sections/packaging-dispatch/view/packaging-dispatch-detail-view';

export default function PackagingDispatchDetailPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Packaging dispatch details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_PACKAGING_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingDispatchDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
